import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-digital-identity-authoring-tools",
  templateUrl: "./digital-identity-authoring-tools.component.html",
  styleUrls: ["./digital-identity-authoring-tools.component.scss"],
})
export class DigitalIdentityAuthoringToolsComponent {
  constructor(private router: Router) {}
  sidebarActive: boolean = true;

  identityProvisioning() {
    this.router.navigate(["digital-identity/auth-tools/identity-provisioning"]);
  }
  back() {
    this.router.navigate(["digital-identity/tools"]);
  }
  auditTrailAuthoring() {
    this.router.navigate(["digital-identity/auth-tools/audit-trail-auth"]);
  }
  identityaAdminPanel() {
    this.router.navigate(["digital-identity/auth-tools/identity-admin-panel"]);
  }
}
